import { useAbility as a } from "@casl/vue";
import { u as r } from "../stores/auth.al0TMRKc.js";
import { s as o } from "./setRedirectCookie.BG84xRGr.js";
import { g as u } from "./getAppUrl.zOygEGj2.js";
async function d() {
  const e = r();
  if (!e.hasCheckedUser) {
    const t = a();
    await e.loadUser(), t.update(e.ability), e.hasCheckedUser = !0;
  }
  return null;
}
function p(e) {
  const t = r();
  return e.name !== "logout" && e.name !== "not-authorised" && e.meta.public !== !0 && t.isSignedIn === !1 && (o(e.fullPath), window.location.replace(u("home"))), null;
}
function f(e) {
  var i, s;
  if (r().isSignedIn === !0 && ((i = e.meta.permission) != null && i.action) && ((s = e.meta.permission) != null && s.subject)) {
    const { can: n } = a();
    if (!n(e.meta.permission.action, e.meta.permission.subject))
      return console.warn(`User not authorised to access: ${e.fullPath}}`), { name: "not-authorised" };
  }
  return null;
}
export {
  p as l,
  f as p,
  d as u
};
